import * as React from 'react';
import { LoginForm } from '../components/LoginForm';
import { RouteComponentProps, StaticContext } from 'react-router';
import { LOG_TAG } from '../const';
import { AuthData, useAuth } from '@mc/react-auth';
import { Redirect } from 'react-router-dom';
import { ROUTE_LOGIN } from '@mc/react-app-base';

export const LoginRedirectPage: React.FC<{}> = () => {
  // @ts-ignore
  return <Redirect to={ROUTE_LOGIN} />;
};

type Props = RouteComponentProps<
  {},
  StaticContext,
  { from: string; originalState?: string; fromOriginalUrl?: string }
> & { onLogin?: (authData: AuthData) => void } & Omit<
    LoginPageProps,
    'onLoginSuccess'
  >;

export type LoginPageProps = React.ComponentProps<typeof LoginForm>;

export const LoginPage: React.FC<Props> = ({
  history,
  location: { state },
  onLogin,
  redirect,
  ...other
}) => {
  let pathname = '/';
  if (state?.from) {
    pathname = history.location.state.from;
  }
  let originalUrl = undefined;
  if (state?.fromOriginalUrl) {
    originalUrl = history.location.state.fromOriginalUrl;
  }

  const outputRedirect = redirect || pathname;

  let auth = useAuth();

  if (auth?.data?.securityMode === 'EXTERNAL') {
    // @ts-ignore
    const serverContextPath = window?.appConfig?.serverContextPath || '';
    window.location.href =
      serverContextPath +
      '/login?spring-security-redirect=' +
      encodeURIComponent(outputRedirect);
    return null;
  }

  const onSubmitSuccess = (auth: AuthData) => {
    let newState = undefined;
    if (state?.originalState !== undefined) {
      try {
        newState = JSON.parse(state.originalState);
      } catch (e) {
        console.warn(
          LOG_TAG,
          '[LoginPage]: Invalid state in history',
          state.originalState
        );
      }
    }
    if (outputRedirect) {
      history.replace({ pathname: outputRedirect });
    } else {
      history.replace({ pathname: outputRedirect, state: newState });
    }
    onLogin && onLogin(auth);
  };

  if (auth.isLoggedIn) {
    // @ts-ignore
    return <Redirect to={outputRedirect} />;
  }

  return (
    <LoginForm
      redirect={outputRedirect}
      serverRedirect={originalUrl}
      {...other}
      onLoginSuccess={onSubmitSuccess}
    />
  );
};
